import { ChangeEvent, SyntheticEvent, useContext, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import commonStyles from "../common.module.css";
import { AuthSetPasswordPayload } from "../../api/types/auth";
import { FormErrors } from "../../api/types/base";
import { classNames } from "primereact/utils";
import { useNavigate, useParams } from "react-router-dom";
import { appToastContext } from "../../context/toast";
import { useSetPassword } from "../../api/queries/auth/useSetPassword";

export default function AuthSetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const setNewPassword = useSetPassword();
  const { ref: appToastRef } = useContext(appToastContext);

  const [email, setEmail] = useState<string>("");
  const onEmailChange = (event: ChangeEvent<HTMLInputElement>) =>
    setEmail(event.target.value);

  const [password, setPassword] = useState<string>("");
  const onPasswordChange = (event: ChangeEvent<HTMLInputElement>) =>
    setPassword(event.target.value);

  const [passwordConfirm, setPasswordConfirm] = useState<string>("");
  const onPasswordConfirmChange = (event: ChangeEvent<HTMLInputElement>) =>
    setPasswordConfirm(event.target.value);

  const [errors, setErrors] = useState<FormErrors<AuthSetPasswordPayload>>();
  const validate = (): boolean => {
    let newErrors: FormErrors<AuthSetPasswordPayload> = {};

    if (!email) {
      newErrors.email = "";
    }

    if (!password) {
      newErrors.password = "";
    }

    if (!passwordConfirm) {
      newErrors.password_confirm = "";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();

    if (!validate() || !token) {
      return;
    }

    await setNewPassword.mutateAsync({
      email,
      password,
      password_confirm: passwordConfirm,
      token,
    });

    appToastRef?.current?.show({
      severity: "info",
      summary: "The password has been successfully updated.",
    });

    navigate("/login");
  };

  return (
    <form className={"col-12 p-fluid"} onSubmit={handleSubmit}>
      <Card
        title={"Set password"}
        className={"col-12 md:col-4 md:col-offset-4"}
      >
        <div className={"field"}>
          <label className={commonStyles.labelRequired}>E-mail:</label>
          <InputText
            value={email}
            onChange={onEmailChange}
            className={classNames({
              "p-invalid": errors?.hasOwnProperty("email"),
            })}
          />
        </div>

        <div className={"field"}>
          <label className={commonStyles.labelRequired}>New password:</label>
          <InputText
            type="password"
            value={password}
            onChange={onPasswordChange}
            className={classNames({
              "p-invalid": errors?.hasOwnProperty("password"),
            })}
          />
        </div>

        <div className={"field"}>
          <label className={commonStyles.labelRequired}>
            New password confirmation:
          </label>
          <InputText
            type="password"
            value={passwordConfirm}
            onChange={onPasswordConfirmChange}
            className={classNames({
              "p-invalid": errors?.hasOwnProperty("password_confirm"),
            })}
          />
        </div>

        <Button label={"Set password"} />
      </Card>
    </form>
  );
}
